export const API_ENDPOINTS = {
  GET_RECOGNIZED_EMPLOYEE: () => `/employee-notes/by-empId `,

  GET_RECOGNIZED: () => `/employee-notes`,

  ADD_RECOGNIZED: () => `/employee-notes`,
  UPDATE_RECOGNIZED: (id) => `/employee-notes/${id}`,
  DELETE_RECOGNIZED: (id) => `/employee-notes/${id}`,
};
